import React, { Component } from 'react';
import { connect } from 'react-redux';
import TopNav                   from './TopNav.jsx';
import MessageBar               from './MessageBar.jsx';
import EnrollCommerceBar        from './EnrollCommerceBar.jsx';
import MemberCommerceBar        from './MemberCommerceBar.jsx';
import Footer                   from './Footer.jsx';
import ModalCustomer            from './ModalCustomer.jsx';
import ModalCart                from './ModalCart.jsx';
import ModalItemRemoval         from './ModalItemRemoval.jsx';
import ModalMiniCart            from './ModalMiniCart.jsx';
import ModalOrderSuccess        from './ModalOrderSuccess.jsx';
import ModalLogin               from './ModalLogin.jsx';
import ModalForgotPassword      from './ModalForgotPassword.jsx';
import ModalFeaturedSelection      from './ModalFeaturedSelection.jsx';
import ModalUpgradeCatalogAccount from './ModalUpgradeCatalogAccount.jsx';
import ModalEnrollCart          from './ModalEnrollCart.jsx';
import ModalUpgradeFlow         from './ModalUpgradeFlow.jsx';
import ModalBoxDecline          from './ModalBoxDecline.jsx';
import PopupEnrollEmailCapture  from './PopupEnrollEmailCapture.jsx';
import ModalWishlist            from './ModalWishlist.jsx';
import Feedback                 from './Feedback.jsx';
import PriceGuide               from './PriceGuide.jsx';


export class BasePage extends Component {

  constructor(props) {
    super(props);
    this.state = {

      didScroll             : false,
      lastScrollTop         : 0,
      collapseHeaderEls     : false,
      collectEmail          : false,
      showCommerceBar       : true,
      notifications: this.props.customer.notifications
    };
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      // window.addEventListener('scroll', this.handleScroll);
    }
  }

  componentWillReceiveProps(newProps) {
     if(this.props.activeModal === '' && newProps.activeModal === 'cart') //cart is opening
       window.dataLayer.push({event: 'pageview', url: window.location.hostname + "/cart", logged_in: this.props.isLoggedIn});
     else if(this.props.activeModal === 'cart' && newProps.activeModal === '') // cart is closing
       window.dataLayer.push({event: 'pageview', url: window.location.hostname + window.location.pathname, logged_in: this.props.isLoggedIn});
    this.setState({
      showCommerceBar: newProps.path === '/catalog' || newProps.path === '/' || newProps.path === '/search',
      notifications: newProps.customer.notifications
    });
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }

  handleScroll() {
    // this.setState({didScroll: true});
    var scrollPosition = window.scrollY;
    var navbarHeight = 140;
    if (Math.abs(this.state.lastScrollTop - scrollPosition) <= this.props.minScroll) {
      return;
    }
    if (scrollPosition > this.state.lastScrollTop && scrollPosition > navbarHeight){
      // Scroll Down
      this.setState({collapseHeaderEls: true});
    } else {
      // Scroll Up
      if (scrollPosition + window.innerHeight < document.body.scrollHeight) {
        this.setState({collapseHeaderEls: false});
      }
    }
    this.setState({lastScrollTop: scrollPosition});
  }

  render() {
    let notifications       = this.state.notifications;
    let mainContentClass    = this.state.collapseHeaderEls ? " when-header-collapsed" : "";
    let customerCart        = this.props.isLoggedIn && this.props.customer  && this.props.customer.status === 'Active' ? <ModalCart /> : <ModalEnrollCart  />;
    let accountContents     = !this.props.isLoggedIn ? '' : <ModalCustomer /> ;
    let isFixed             = (this.props.activeModal === '' || (this.props.activeModal && this.props.headerDetailsOpen)) ? '' : ' fixed';
    let oPageModal          = <div />;
    let oPopupModal         = <div />;

    let aCommerceBar = this.props.customer && typeof this.props.customer === "object" && this.props.customer.cart
      && this.props.customer.status === 'Active' && !this.props.upgradeStatus ?
                      <MemberCommerceBar {...this.props} /> :
                      <EnrollCommerceBar {...this.props} /> ;


    switch (this.props.activeModal){
      case 'customer':
        oPageModal = (
          <div className={"page-modal account showing"  + mainContentClass}>
            {accountContents}
          </div>
        );
        break;
      case 'wishlist':
        if ( notifications && notifications.wishlist && notifications.wishlist.length > 0) {
          oPopupModal = (
            <div className={"modal-wrapper showing"} >
              <ModalItemRemoval />
            </div>
          );
        } else {
          oPageModal = (
            <div className={"page-modal wishlist showing" + mainContentClass }>
              <ModalWishlist />
            </div>
          );
        }
        break;
      case 'cart':
        if (notifications && notifications.cart && notifications.cart.length > 0) {
          oPopupModal = (
            <div className={"modal-wrapper showing"} >
              <ModalItemRemoval />
            </div>
          );
        } else {
          oPageModal = (
            <div className={"page-modal cart showing" + mainContentClass }>
              {customerCart}
            </div>
          );
        }
        break;
      case 'miniCart':
        oPageModal = (
          <div className="content-max-width">
            <div className={"page-modal mini-cart showing" + mainContentClass}>
              <ModalMiniCart />
            </div>
          </div>
        );
        break;
      case 'orderSuccess':
        oPageModal = (
          <div className="page-modal cart order-success showing">
            <ModalOrderSuccess />
          </div>
        );
        break;
      case 'upgradeFlow':
        oPageModal = (
          <div className="page-modal upgrade showing">
            <ModalUpgradeFlow />
          </div>
          );
        break;
      case 'featuredSelection':
        oPageModal = (
          <div className="modal-wrapper showing">
            <ModalFeaturedSelection />
          </div>
        );
        break;
    }

    return (
      <div className="content-on-screen" >
        <div className={"not-the-footer" + isFixed}>
          <header>
            <div className="top-nav top-nav-wrapper">
              <TopNav />
            </div>
            <div className={(this.state.showCommerceBar ? "showing" : "hidden" )} >
              <MessageBar />
            </div>

            <div className={"content-max-width commerce-bar-wrapper" + ( this.state.showCommerceBar ? " showing" : " hidden" )}>
              {aCommerceBar}
            </div>
          </header>
          <div className={"content-main" + mainContentClass}>
            {this.props.children}
          </div>
        </div>

        <Footer />

      {/*  Begin Modals */}
        {oPageModal}

        {oPopupModal}

        <div className={"modal-wrapper" + ( this.props.activeModal === 'login' ? " showing" : "" ) } >
          <ModalLogin />
        </div>
        <div className={"modal-wrapper" + ( this.props.activeModal === 'forgotPassword' ? " showing" : "" ) } >
          <ModalForgotPassword />
        </div>
        <div className={"modal-wrapper" + ( this.props.activeModal === 'upgradeCatalog' ? " showing" : "" ) } >
          <ModalUpgradeCatalogAccount />
        </div>
        <div className={"modal-wrapper" + ( this.props.activeModal === 'decline' ? " showing" : "" ) } >
          <ModalBoxDecline />
        </div>
        <div className={"modal-wrapper" + ( this.props.activeModal === 'priceGuide' ? " showing" : "" ) } >
          <PriceGuide />
        </div>

        <Feedback />
      </div>
    );
  }
};

BasePage.defaultProps = {
  minScroll: 140
};

function mapStateToProps(state){
    return {
      'path': state.path,
      'activeModal': state.activeModal,
      'customer': state.customer,
      'feedback': state.feedback,
      'headerDetailsOpen': state.headerDetailsOpen,
      'isLoggedIn': state.isLoggedIn,
      'upgradeStatus': state.upgradeStatus,
      'storeType': state.store.type
    };
}

export default connect(mapStateToProps)(BasePage);


// WEBPACK FOOTER //
// ./src/components/BasePage.jsx